import { ref } from "@vue/composition-api";
import config, { setConfig } from "@/config";

export default function useLocalFeatures() {
  const isChangedFeatures = ref(false);
  const initFeatures = () => {
    if (!config.featureFlagsDisplay) return;
    const features = localStorage.getItem("features");
    if (features) {
      setConfig(JSON.parse(features));
      isChangedFeatures.value = true;
    }
  };

  return {
    isChangedFeatures,
    initFeatures,
  };
}
